import React from "react";
import { loader } from "../assets";
import "./styles.css";

const CustomLoader = () => {
  return (
    <div className="mapLoader">
      <div className="loadContainer">
        <img src={loader} alt="" />
      </div>
    </div>
  );
};

export default CustomLoader;
